import { render } from "./ShiftDetailsSidebarItem.vue?vue&type=template&id=0a0bca90&scoped=true&ts=true"
import script from "./ShiftDetailsSidebarItem.vue?vue&type=script&lang=ts"
export * from "./ShiftDetailsSidebarItem.vue?vue&type=script&lang=ts"

import "./ShiftDetailsSidebarItem.vue?vue&type=style&index=0&id=0a0bca90&scoped=true&lang=scss"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a0bca90"]])

export default __exports__